@use '../../styles/variables';
@use '../../styles/mixins';

input {
  border: 0;
  outline: 0;
  cursor: pointer;
}

input[type='date']::-webkit-calendar-picker-indicator {
  position: absolute;
  background: transparent;
  color: transparent;
  height: auto;
  width: auto;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}

.text-input__input {
  min-height: variables.$line-height--normal; // Safari iOS when type="date" gives the wrong height when value is empty
}

.text-input__wrapper--icon {
  align-items: center;
}

.hidden {
  display: none;
}

input[type='date']::-webkit-datetime-edit-text,
input[type='date']::-webkit-datetime-edit-month-field,
input[type='date']::-webkit-datetime-edit-day-field,
input[type='date']::-webkit-datetime-edit-year-field {
  color: variables.$color--black;
}

.calendar-icon {
  position: absolute;
  right: 1rem;
  pointer-events: none;
  cursor: pointer;
}

.close-icon {
  position: absolute;
  background-color: #5adbff;
  border-radius: 100%;
  font-size: 0.75rem;
  right: 1rem;
  margin-right: 2rem;
  cursor: pointer;
}

.text-input {
  $self: &;

  min-width: 0;
  flex: 1;
  text-align: left;
  grid-area: input;

  @include mixins.remove-input-styles;
  @include mixins.font--text;
  &:disabled {
    cursor: not-allowed;
  }

  &--icon {
    $icon-base: &;
    width: mixins.rem(21);
    height: mixins.rem(21);
    font-size: mixins.rem(21);
    line-height: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &-left {
      @extend #{$icon-base};
      margin-right: 12px;
    }
    &-right {
      @extend #{$icon-base};
      margin-left: 12px;
    }
  }

  &__wrapper {
    $input-rapper-base: &;
    position: relative;
    width: 100%;
    // this is the border, using box-shadow to get outline rounded
    // corners on focus and to prevent bouncing when border thickness changes we use box-shadow all the way
    box-shadow: 0 0 0 1px variables.$in--black-50;
    border-radius: 3px;
    background-color: variables.$in--white;
    display: grid;
    grid-template-areas: 'input suffix';
    grid-auto-columns: 1fr auto;
    padding: 10px 12px;
    margin-bottom: 4px;
    transition: box-shadow 50ms ease-in-out;

    &:focus-within {
      @include mixins.focus-border-box-shadow(variables.$in--black-50, 2px, 3px);
      &#{$input-rapper-base}--error {
        @include mixins.focus-border-box-shadow(variables.$in--red-100, 2px, 3px);
      }
    }
    &--error {
      @include mixins.focus-border-box-shadow(variables.$in--red-100, 1px, 0px);
    }
    &:active {
      @include mixins.focus-border-box-shadow(variables.$in--black-50, 2px, 0px);
      &#{$input-rapper-base}--error {
        @include mixins.focus-border-box-shadow(variables.$in--red-100, 2px, 0px);
      }
    }

    &--max-width {
      max-width: 5em;
    }

    &--icon {
      display: flex;
      justify-content: space-between;
    }

    &--disabled {
      background: variables.$in--disabled;
      cursor: not-allowed;
      @include mixins.focus-border-box-shadow(variables.$in--black-25, 1px, 0px);

      #{$self}--icon,
      #{$self}--icon-left,
      #{$self}--icon-right {
        path {
          fill: variables.$in--black-25;
        }
      }
    }
  }
}
